/*
  Kaufart im Warenkorb wechseln.

  Im Checkout selbst lässt sich ein Abo nicht mehr an- oder abwählen, das
  gibt Shopify nicht her. Der letzte Punkt, an dem es geht, ist der
  Warenkorb. Die Auswahl dort schreibt die gewählte Lieferung über
  /cart/change.js auf die Position und lädt den Warenkorb neu, damit
  Preise, Rabatte und Zwischensumme stimmen.
*/
(() => {
  if (window.__wauwowWarenkorb) return;
  window.__wauwowWarenkorb = true;

  const laufend = new Set();

  const wechseln = async (feld) => {
    const schluessel = feld.dataset.schluessel;
    if (!schluessel || laufend.has(schluessel)) return;

    laufend.add(schluessel);
    feld.disabled = true;

    const nutzlast = { id: schluessel };
    // Ein leerer Wert bedeutet Einmalkauf. Shopify erwartet dafür
    // ausdrücklich null, ein leerer Text würde abgewiesen.
    nutzlast.selling_plan = feld.value ? Number(feld.value) : null;

    try {
      const antwort = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nutzlast),
      });
      if (!antwort.ok) throw new Error(await antwort.text());
      window.location.reload();
    } catch (e) {
      feld.disabled = false;
      laufend.delete(schluessel);
      console.error('Kaufart konnte nicht gewechselt werden:', e);
    }
  };

  document.addEventListener('change', (e) => {
    const ziel = e.target;
    if (ziel && ziel.matches && ziel.matches('[data-abo-warenkorb]')) {
      wechseln(ziel);
    }
  });
})();
